import { TelevisionShimmerIcon } from './TelevisionShimmerIcon';

/**
 * author: kevin-hens
 * id 9132E544-8FAA-43BA-98B4-8D752CB3E251
 * name television-shimmer
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-shimmer.svg
 * tags
 * - Device / Tech 
 */
export const TelevisionCleanIcon = TelevisionShimmerIcon;
export default TelevisionCleanIcon